import { Box, Flex, Icon, Spinner, keyframes } from '@chakra-ui/react'
import { FaShippingFast } from 'react-icons/fa'

export function Loader() {
  const animationCube = keyframes`
    0% {

        transform: translateY(-10px);
    } 
    100% {
        transform: translateY(0px);
    }
`

  const animationColorShipping = keyframes`
    0% {
        color: #95C620;
    }
    50% {
        color: #F2C94C;
    }
    100% {
        color: #95C620;
    }
`

  return (
    <Box
      position="fixed"
      top="0"
      left="0"
      w="100vw"
      h="100vh"
      bg="rgba(0,0,0,0.5)"
      zIndex="9999"
    >
      <Flex justifyContent="center" alignItems="center" w="100%" h="100%">
        <Flex
          flexDir="column"
          justifyContent="center"
          alignItems="center"
          w="100%"
          h="100%"
          animation={`${animationCube} 1s`}
          zIndex="99999"
          position="relative"
        >
          <Icon
            as={FaShippingFast}
            fontSize="5rem"
            animation={`${animationColorShipping} 2s infinite`}
          />

          <Box mt="1rem" fontSize="1.5rem" color="#95C620">
            Aguarde...
          </Box>
          <Box mt="1rem" fontSize="1.5rem" color="#95C620">
            Estamos calculando o frete...
          </Box>
        </Flex>
      </Flex>
    </Box>
  )
}
